/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/application_flow/application_flow';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "RetrieveApplicationFlowRequest": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RetrieveApplicationFlowResponse": {
                "fields": {
                  "applicationFlow": {
                    "type": ".squareup.corporate_card.resources.application_flow.ApplicationFlow",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveApplicationFlowRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.RetrieveApplicationFlowResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE RetrieveApplicationFlowRequest @ squareup/corporate_card/service/retrieve_application_flow.proto at 10:1
 */
export const RetrieveApplicationFlowRequest = $root.lookupType('squareup.corporate_card.service.RetrieveApplicationFlowRequest');
fixType(RetrieveApplicationFlowRequest, {
  id: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(RetrieveApplicationFlowRequest);
/**
 * SOURCE RetrieveApplicationFlowResponse @ squareup/corporate_card/service/retrieve_application_flow.proto at 19:1
 */
export const RetrieveApplicationFlowResponse = $root.lookupType('squareup.corporate_card.service.RetrieveApplicationFlowResponse');
fixType(RetrieveApplicationFlowResponse);
Builder.createAndAttachToType(RetrieveApplicationFlowResponse);